import { type FunctionComponent, type PropsWithChildren } from "react";

import { ChildrenWrapper, StyledLink } from "./DetailLink.sc";

interface DetailLinkProps {
    to: string;
}
const DetailLink: FunctionComponent<PropsWithChildren<DetailLinkProps>> = ({ to, children }) => {
    return (
        <StyledLink
            to={{
                pathname: to,
            }}
        >
            <ChildrenWrapper>{children}</ChildrenWrapper>
        </StyledLink>
    );
};

export default DetailLink;
